import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-skeleton-rect',
  template: `
    <div class="skeleton-rect" [ngClass]="customClass + ' ' + class" [style.width]="width" [style.height]="height" [style.borderRadius]="borderRadius"></div>
  `,
  styles: [
    `
    :host {
      display: inline-block;
    }

    .skeleton-rect {
      display: block;
      width: 100%;
      height: 16px;
      border-radius: 6px;
      background: linear-gradient(90deg, rgba(0,0,0,0.06) 25%, rgba(0,0,0,0.12) 37%, rgba(0,0,0,0.06) 63%);
      background-size: 400% 100%;
      animation: skeleton-shimmer 1.2s ease-in-out infinite;
    }

    @keyframes skeleton-shimmer {
      0% { background-position: 100% 0; }
      100% { background-position: -100% 0; }
    }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class SkeletonRectComponent {
  @Input() width: string = '100%';
  @Input() height: string = '16px';
  @Input() customClass: string = '';
  @Input() class: string = '';
  @Input() borderRadius: string = '6px';
}


